import React, { useContext, useState } from 'react'
import './Navbar.css'
import { assets } from '../../assets/assets'
import { Link, useNavigate } from 'react-router-dom';
import { StoreContext } from '../../context/StoreContex';

const Navbar = ({ setShowLogin }) => {

  const [menu, setMenu] = useState("home");
  const { getTotalCartAmount, loginState,setLoginState } = useContext(StoreContext);
  const navigate = useNavigate();
  
  const logoutHandler = async () => { 
     localStorage.removeItem('token');
     setLoginState('');
  }
  return (
    <div className='navbar'>
      <Link to='/'><img src={assets.logo} alt="storename logo" /></Link>
      <ul className='navbar-menu'>
        <Link to='/' onClick={() => setMenu("home")} className={menu === "home" ? "active" : ""}>Home</Link>
        <a href='/#explore-menu' onClick={() => setMenu("menu")} className={menu === "menu" ? "active" : ""}>Menu</a>
        {/* <a href='/#app-download' onClick={() => setMenu("mobile-app")} className={menu === "mobile-app" ? "active" : ""}>Mobile App</a> */}
        <a href='#footer' onClick={() => setMenu("contact-us")} className={menu === "contact-us" ? "active" : ""}>Contact Us</a>
      </ul>
      <div className='navbar-right'>
        <img src={assets.search_icon} alt="" />
        <div className='navbar-search-icon'>
          <Link to="/cart"><img src={assets.basket_icon} alt="" /></Link>
          <div className={getTotalCartAmount() === 0 ? "" : "dot"}>

          </div>
        </div>
        {loginState === 'Login' ? 
          <button onClick={()=>logoutHandler()}>Log Out</button>
          : <button onClick={() => navigate("/login")}>Sign In</button>
        }

      </div>
    </div>
  )
}

export default Navbar